// Arabic
const lang = {
    contact: 'اتصال',
    born: 'مولود',
    bornIn: 'ب',
    experience: 'خبرة مهنية',
    education: 'تكوين',
    skills: 'مهارات',
    projects: 'مشاريع',
    contributions: 'مساهمات',
    about: 'معلومات عني',
    today: 'اليوم',
    loading: 'جاري الإعداد...',
    error: 'حدث خلل مؤسف'
};
export default lang;
